<template>
    <div class="flexContainer full">
        <main class="main-container flexContainer t-fd-r full m-fd-c">
            <section class="flexContainer primary-bloc fd-c size12of12 col m-w-full">
                <div class="flexContainer full jc-fe m-jc-c">
                    <div class="content-button">
                        <router-link tag="button" class="btn pointer uppercase create" to="/plano/config/carcass"
                            >+ {{ $t("displayer.create") }}</router-link
                        >
                    </div>
                </div>
                <section class="flexContainer full"><List :items="items"></List></section>

                <div class="flexContainer full jc-fe m-jc-c">
                    <div class="content-button">
                        <router-link tag="button" class="btn pointer uppercase create" to="/plano/config/carcass"
                            >+ {{ $t("displayer.create") }}</router-link
                        >
                    </div>
                </div>
            </section>
        </main>
    </div>
</template>
<script>
import httpService from "../service";
import List from "../gui/list/List.vue";
import { mapActions } from "vuex";
import { i18n } from "../../main.js";
import { carcassmodel } from "../../store/planonext/carcassmodel";

export default {
    components: { List },
    data() {
        return {
            displayers: [],
            items: []
        };
    },
    created() {
        httpService.get("/displayers?flags=0").then(res => {
            this.displayers = res.data;
            let item;
            this.displayers.forEach((displayer, i) => {
                this.items.push({
                    name: displayer.name,
                    systemType: displayer.systemType,
                    id: displayer.id,
                    brand: displayer.brand,
                    size: displayer.widthExternal + "x" + displayer.heightExternal,
                    user: displayer.createdUser,
                    standDesign: displayer.standDesign,
                    visiblility: "Public",
                    status: "active",
                    actions: [
                        {
                            action: this.edit,
                            label: "edit",
                            args: [displayer.id, displayer]
                        },
                        {
                            action: this.delete,
                            label: "delete",
                            args: [displayer.id]
                        }
                    ]
                });
            });
        });
    },

    methods: {
        ...mapActions({
            setEditDisplay: "items/setEditDisplay"
        }),
        edit(id, displayer) {
            this.setEditDisplay(id);
            if (displayer.systemType.id === carcassmodel.PLANO_TILE) {
                this.$router.push("/edit-displayer");
            } else {
                this.$router.push(`/templates/${id}`);
            }
        },
        delete(a) {
            let self = this;
            let confirmTitle;
            let warningText;
            if (i18n.locale === "fr") {
                confirmTitle = "ERROR";
                warningText = "Ce display ne peut être supprimé car il est utilisé en référence par des planogrammes!";
            } else if (i18n.locale === "en") {
                confirmTitle = "ERROR";
                warningText = "This display cannot be deleted because it's being used by some planograms";
            }
            httpService.get("/admin/displayers/" + a + "/used").then(response => {
                if (response === "Displayer has been used") {
                    self.$swal({
                        html: confirmTitle + "<br />" + warningText,
                        type: "warning",
                        showCancelButton: false,
                        confirmButtonColor: "red",
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                        confirmButtonText: "OK"
                    }).then(result => {});
                } else {
                    httpService.delete("/admin/displayers/" + a).then(function(response) {
                        self.$swal({
                            html: "SUCCESS",
                            type: "success",
                            showCancelButton: false,
                            confirmButtonColor: "green",
                            allowOutsideClick: false,
                            allowEscapeKey: false,
                            confirmButtonText: "OK"
                        }).then(result => {
                            location.reload();
                        });
                    });
                }
            });
        }
    }
};
</script>
<style scoped lang="scss">
@import "../../assets/css/themes.scss";

aside {
    margin-right: 1rem;

    h3 {
        font-size: 18px;
        font-family: Roboto;
        color: #343434;
        padding: 20px 30px;
    }
}

.col {
    padding: 1rem;
    @extend %primary-bloc;
}

.create,
a {
    text-decoration: none;
    color: #fff;
    margin: 10px 0;
}

.content-button {
    text-align: right;
    padding: 5px;
}
</style>



// WEBPACK FOOTER //
// Displayers.vue?7353efca